export default "/images/3f3c6f0d3d5ac9f3b6301638a4d45d90.avif";